import React from 'react';

import { StyleUtil } from '../../util';
import classNames from './EABD2CircleButton.module.scss';

export interface CircleButtonProps
  extends Readonly<{
    text: string;
    circlePosition: 'before' | 'after';
    arrowDirection: 'left' | 'right';
    onPress: () => void;
    shouldFadeIn?: boolean;
  }> {}

export const CircleButton = React.memo<CircleButtonProps>((props) => {
  const { text, circlePosition, arrowDirection, onPress, shouldFadeIn = false } = props;

  const RootClassNames = React.useMemo<string>(() => {
    const rootClassNames = StyleUtil.createInitialClassNameArray(classNames.root);

    if (shouldFadeIn) {
      rootClassNames.push(classNames.fadeIn);
    }

    return StyleUtil.mergeClassNames(rootClassNames);
  }, [shouldFadeIn]);

  const ArrowElement = React.useMemo(() => {
    const arrowClassNames = StyleUtil.createInitialClassNameArray(classNames.arrow);

    arrowClassNames.push(classNames[arrowDirection]);

    return <div className={StyleUtil.mergeClassNames(arrowClassNames)} />;
  }, [arrowDirection]);

  const CircleElement = React.useMemo(() => {
    const circleClassNames = StyleUtil.createInitialClassNameArray(classNames.circle);

    circleClassNames.push(classNames[circlePosition]);

    return <div className={StyleUtil.mergeClassNames(circleClassNames)}>{ArrowElement}</div>;
  }, [circlePosition, ArrowElement]);

  return (
    <button onClick={onPress} type={'button'} className={RootClassNames}>
      {circlePosition === 'before' && CircleElement}
      <span className={classNames.text}>{text}</span>
      {circlePosition === 'after' && CircleElement}
    </button>
  );
});
